<template>
  <button class="btn"
    @click="$emit('click', $event)"
    @mouseenter="$emit('mouseenter', $event)"
    @mouseleave="$emit('mouseleave', $event)"
    :disabled="disabled"
  >
    <slot></slot>
  </button>
</template>

<script>

  export default {
    name: 'Btn',
    props: {
      disabled: {
        type: Boolean,
        defaultTo: false
      }
    }
  }

</script>

<style lang="scss" scoped>

  @import "~globals";

  .btn {
    @include transition();
    @include button-reset;
    display:inline-block; padding:.5em 1.25em; border-radius:5px; text-align:center; color:lighten($color-black, 30%); text-decoration:none; cursor:pointer; border:1px solid lighten($color-black, 70%); font-size:1.8rem; line-height:1; overflow:hidden;
    &[type=submit] {
      background-color:$color-primary; border-color:$color-primary; color:$color-white;
      &:hover {
        color:$color-white;
      }
    }
    &[disabled] {
      background-color:$color-white; border-color:$color-gray; color:$color-gray; pointer-events:none;
    }
    &:hover, &:focus {
      border-color:$color-primary; color:$color-primary;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/_global/btn.vue